import { analytics, SandboxEvents } from '@/lib/analytics'
import type { SandboxSource } from '@/stores/sandbox-dialog'

interface SandboxBannerEventData {
  source: SandboxSource
  userRole: 'Administrator' | 'User'
  currentPlan: string
  isManaged: boolean
}

export function trackSandboxBannerViewed(data: SandboxBannerEventData): void {
  analytics.track(SandboxEvents.BANNER_VIEWED, {
    source: data.source,
    user_role: data.userRole,
    current_plan: data.currentPlan,
    is_managed: data.isManaged,
  })
}

export function trackSandboxBannerClicked(data: SandboxBannerEventData): void {
  analytics.track(SandboxEvents.BANNER_CLICKED, {
    source: data.source,
    user_role: data.userRole,
    current_plan: data.currentPlan,
    is_managed: data.isManaged,
  })
}
